// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44c0e2c1","453":"818670aa","455":"27dd5393","977":"88299d30"}[chunkId] + ".chunk.js";
};